import axios from 'axios';
import store from '../store';

class GlobalLoadingService {
  constructor() {
    this.requestInterceptor = null;
    this.responseInterceptor = null;
    this.isInitialized = false;
  }

  init() {
    if (this.isInitialized) return;

    // Request interceptor
    this.requestInterceptor = axios.interceptors.request.use(
      (config) => {
        // Only show loading for API requests (not for assets, etc.)
        if (this.shouldShowLoading(config)) {
          const message = this.getLoadingMessage(config);
          store.dispatch('globalLoading/showLoading', message);
        }
        return config;
      },
      (error) => {
        store.dispatch('globalLoading/hideLoading');
        return Promise.reject(error);
      }
    );

    // Response interceptor
    this.responseInterceptor = axios.interceptors.response.use(
      (response) => {
        store.dispatch('globalLoading/hideLoading');
        return response;
      },
      (error) => {
        store.dispatch('globalLoading/hideLoading');
        return Promise.reject(error);
      }
    );

    this.isInitialized = true;
  }

  destroy() {
    if (this.requestInterceptor) {
      axios.interceptors.request.eject(this.requestInterceptor);
    }
    if (this.responseInterceptor) {
      axios.interceptors.response.eject(this.responseInterceptor);
    }
    this.isInitialized = false;
  }

  shouldShowLoading(config) {
    // Skip loading for certain types of requests
    const skipPatterns = [
      /\/assets\//,
      /\/images\//,
      /\/static\//,
      /\.(png|jpg|jpeg|gif|svg|css|js)$/,
    ];

    const url = config.url || '';
    return !skipPatterns.some(pattern => pattern.test(url));
  }

  getLoadingMessage(config) {
    // Custom messages based on request type
    const method = config.method?.toUpperCase();
    const url = config.url || '';

    if (method === 'POST') return 'Salvando...';
    if (method === 'PUT') return 'Atualizando...';
    if (method === 'DELETE') return 'Excluindo...';
    if (url.includes('upload')) return 'Enviando...';
    if (url.includes('export')) return 'Preparando download...';
    
    return 'Carregando...';
  }

  // Manual control methods
  show(message = 'Carregando...') {
    store.dispatch('globalLoading/showLoading', message);
  }

  hide() {
    store.dispatch('globalLoading/hideLoading');
  }

  setMessage(message) {
    store.dispatch('globalLoading/setLoadingMessage', message);
  }

  reset() {
    store.commit('globalLoading/RESET_LOADING');
  }
}

const globalLoadingService = new GlobalLoadingService();
export default globalLoadingService;